<template>
  <router-view />
</template>

<script>
export default {
  name: 'Client'
}
</script>

<style scoped>

</style>
